(function(){

  var FORM_ENDPOINT =
    "https://formspree.io/f/YOUR_FORM_ID";

  var VIRUS_PHOTOS = [
    "https://cdn.shopify.com/s/files/1/1008/7845/1059/files/IMG-2914.jpg?v=1786766060",
    "https://cdn.shopify.com/s/files/1/1008/7845/1059/files/IMG-2913.jpg?v=1786766060",
    "https://cdn.shopify.com/s/files/1/1008/7845/1059/files/IMG-2912.jpg?v=1786766060",
    "https://cdn.shopify.com/s/files/1/1008/7845/1059/files/IMG-2911.jpg?v=1786766060",
    "https://cdn.shopify.com/s/files/1/1008/7845/1059/files/IMG-2910.jpg?v=1786766060",
    "https://cdn.shopify.com/s/files/1/1008/7845/1059/files/IMG-2909.jpg?v=1786766060",
    "https://cdn.shopify.com/s/files/1/1008/7845/1059/files/IMG-2908.jpg?v=1786766060",
    "https://cdn.shopify.com/s/files/1/1008/7845/1059/files/IMG-2907.jpg?v=1786766060",
    "https://cdn.shopify.com/s/files/1/1008/7845/1059/files/C419768A-C999-41C0-B250-2A4479F2A100.jpg?v=1786766075"
  ];

  var quizPhotos = {
    1:"https://cdn.shopify.com/s/files/1/1008/7845/1059/files/D697399B-F552-476C-B9F3-AB150BE53D3D.jpg?v=1786764432",
    4:"https://cdn.shopify.com/s/files/1/1008/7845/1059/files/73889D25-704C-4D24-9413-8A227CBD6D6B.jpg?v=1786764432",
    7:"https://cdn.shopify.com/s/files/1/1008/7845/1059/files/IMG-2906.jpg?v=1786764498"
  };

  var questions = [
    {
      q:"What's my favorite number?",
      a:["7","10","11","9"],
      correct:2,
      message:"Okay good. You know your own son. 😂",
      rage:false
    },
    {
      q:"What year did we go to Spain?",
      a:["2017","2018","2019","2020"],
      correct:2,
      message:"España 2019 🇪🇸 You remembered.",
      rage:false
    },
    {
      q:"What's my favorite color?",
      a:["Red","Blue","Black","Green"],
      correct:2,
      message:"The official system says Black. Your appeal has been denied. 😭",
      rage:true
    },
    {
      q:"What's Mom's go-to drink?",
      a:["Margarita","Wine","Modelo","Coffee"],
      correct:2,
      message:"MODELO 🍺 Easy money.",
      rage:false
    },
    {
      q:"What is Mom most likely to do on vacation?",
      a:["Wake up at 5 AM","Go shopping","Run a marathon","Study tax law"],
      correct:1,
      message:"Shopping. Obviously. 🛍️",
      rage:false
    },
    {
      q:"Who's most likely to get everyone lost on vacation?",
      a:["Mom","Dad","Me","Google Maps"],
      correct:3,
      message:"Official investigation blamed Google Maps. Dad has been cleared of all charges. 😂",
      rage:true
    },
    {
      q:"How old is the birthday girl today?",
      a:["39 again","42","45","25"],
      correct:3,
      message:"45?? Wrong attitude. Official answer: 25. ❤️",
      rage:true
    },
    {
      q:"Who deserves a weekend getaway the most?",
      a:["Dad","Me","Mom","The Amazon driver"],
      correct:2,
      message:"Correct. Sorry everyone else. 😂",
      rage:false
    },
    {
      q:"What's Mom NOT allowed to worry about on this trip?",
      a:["Work","Errands","Everyone else","All of the above"],
      correct:3,
      message:"Correct. Absolutely NONE of it.",
      rage:false
    },
    {
      q:"Final question: how much do I love you?",
      a:["$5 worth","$50 worth","$500 worth","More than money could measure ❤️"],
      correct:3,
      message:"Okay fine. That answer can have $5. ❤️",
      rage:false
    }
  ];

  var index = 0;
  var score = 0;
  var locked = false;
  var trip = "";
  var upgrade = "";
  var virusPlayed = false;

  function el(id){
    return document.getElementById(id);
  }

  function show(id){

    var screens =
      document.querySelectorAll("#mom-birthday-app .screen");

    screens.forEach(function(screen){
      screen.classList.remove("active");
    });

    var target = el(id);

    if(target){
      target.classList.add("active");
      target.scrollTop = 0;
    }
  }

  function updateMoney(){
    el("mom-money").textContent = score;
  }

  function pop(text){

    var item =
      document.createElement("div");

    item.className = "pop";
    item.textContent = text;

    el("mom-birthday-app").appendChild(item);

    window.setTimeout(function(){

      if(item.parentNode){
        item.remove();
      }

    },1000);
  }

  function loadQuestion(){

    locked = false;

    var data = questions[index];

    el("mom-q-number").textContent =
      "QUESTION " +
      (index + 1) +
      " OF " +
      questions.length;

    el("mom-q-text").textContent =
      data.q;

    el("mom-feedback").className =
      "feedback";

    el("mom-feedback").innerHTML =
      "";

    el("mom-rage-next").style.display =
      "none";

    var photoWrap =
      el("mom-quiz-photo-wrap");

    var photo =
      el("mom-quiz-photo");

    if(quizPhotos[index]){

      photo.src =
        quizPhotos[index];

      photoWrap.classList.add(
        "show"
      );

    }else{

      photoWrap.classList.remove(
        "show"
      );

      photo.src = "";
    }

    var answers =
      el("mom-answers");

    answers.innerHTML = "";

    data.a.forEach(function(answer,answerIndex){

      var button =
        document.createElement("button");

      button.type =
        "button";

      button.className =
        "answer";

      button.textContent =
        answer;

      button.addEventListener(
        "click",
        function(){

          answerQuestion(
            answerIndex,
            button
          );

        }
      );

      answers.appendChild(
        button
      );
    });
  }

  function answerQuestion(answerIndex,button){

    if(locked){
      return;
    }

    locked = true;

    var data =
      questions[index];

    var buttons =
      document.querySelectorAll(
        "#mom-answers .answer"
      );

    var feedback =
      el("mom-feedback");

    var isCorrect =
      answerIndex === data.correct;

    if(isCorrect){

      score =
        score + 5;

      updateMoney();

      button.classList.add(
        "correct"
      );

      feedback.innerHTML =
        data.message +
        '<span class="money-added">+$5</span>';

      pop(
        data.rage
          ? "APPARENTLY CORRECT 😭"
          : "+$5"
      );

    }else{

      button.classList.add(
        "wrong"
      );

      if(buttons[data.correct]){

        buttons[data.correct]
          .classList.add(
            "correct"
          );
      }

      if(data.rage){

        feedback.innerHTML =
          '<span class="rage-tag">OFFICIAL RULING • NO APPEALS</span><br>' +
          data.message +
          '<span class="money-added">$0 😭</span>';

        pop("WRONG 😭");

      }else{

        feedback.innerHTML =
          "NOOO 😭 The answer was <strong>" +
          data.a[data.correct] +
          '</strong>.<span class="money-added">$0</span>';

      }
    }

    feedback.classList.add(
      "show"
    );

    if(data.rage){

      el("mom-rage-next")
        .style.display =
        "inline-block";

      return;
    }

    window.setTimeout(
      function(){
        advance();
      },
      isCorrect
        ? 2800
        : 4700
    );
  }

  function advance(){

    index =
      index + 1;

    if(index === 2){

      show(
        "mom-shoutout1"
      );

      return;
    }

    if(index === 3){

      show(
        "mom-getaway1"
      );

      return;
    }

    if(index === 5){

      show(
        "mom-shoutout2"
      );

      return;
    }

    if(index === 6){

      show(
        "mom-getaway2"
      );

      return;
    }

    if(index === 8){

      show(
        "mom-shoutout3"
      );

      return;
    }

    if(
      index === 9 &&
      !virusPlayed
    ){

      virusPlayed =
        true;

      runVirusPrank();

      return;
    }

    if(
      index >=
      questions.length
    ){

      show(
        "mom-rage-screen"
      );

      return;
    }

    show(
      "mom-quiz"
    );

    loadQuestion();
  }

  function addFakePopup(title,message,delay){

    window.setTimeout(function(){

      var overlay =
        el("mom-virus-overlay");

      overlay.classList.add(
        "active"
      );

      var popup =
        document.createElement(
          "div"
        );

      popup.className =
        "virus-popup";

      popup.style.left =
        Math.floor(
          Math.random()*60
        ) + "%";

      popup.style.top =
        Math.floor(
          Math.random()*65
        ) + "%";

      popup.innerHTML =
        '<div class="virus-popup-bar">' +
        title +
        '</div>' +

        '<div class="virus-popup-body">' +

        '<div class="virus-popup-icon">⚠️</div>' +

        '<div>' +
        message +
        '</div>' +

        '</div>' +

        '<div class="virus-popup-buttons">' +

        '<span class="fake-window-button">OK</span>' +

        '</div>';

      overlay.appendChild(
        popup
      );

    },delay);
  }

  function runVirusPrank(){

    show(
      "mom-virus"
    );

    var app =
      el("mom-birthday-app");

    var title =
      el("mom-virus-title");

    var log =
      el("mom-virus-log");

    var fill =
      el("mom-virus-fill");

    var percent =
      el("mom-virus-percent");

    var glitch =
      el("mom-virus-glitch");

    var popupOverlay =
      el("mom-virus-overlay");

    popupOverlay.innerHTML =
      "";

    popupOverlay.classList.remove(
      "active"
    );

    fill.style.width =
      "0%";

    percent.textContent =
      "0%";

    title.textContent =
      "Critical system error detected.";

    log.innerHTML =
      "Initializing emergency diagnostic...";

    window.setTimeout(function(){

      fill.style.width =
        "11%";

      percent.textContent =
        "11%";

      log.innerHTML =
        "Checking browser memory...<br>" +
        "Checking birthday assets...<br>" +
        "Checking Michael's questionable code...";

    },800);

    window.setTimeout(function(){

      fill.style.width =
        "27%";

      percent.textContent =
        "27%";

      title.textContent =
        "⚠ SECURITY BREACH DETECTED";

      log.innerHTML =
        "Unauthorized process found:<br>" +
        "MOM_BIRTHDAY_PRANK.exe<br><br>" +
        "Threat level: SUSPICIOUS";

    },2100);

    addFakePopup(
      "Security Warning",
      "Suspicious birthday activity detected.",
      3000
    );

    window.setTimeout(function(){

      fill.style.width =
        "41%";

      percent.textContent =
        "41%";

      glitch.classList.add(
        "active"
      );

      app.classList.add(
        "virus-shake"
      );

      log.innerHTML =
        "WARNING: PHOTO DIRECTORY ACCESS ATTEMPT<br>" +
        "Accessing /MOM/FUNNY_PHOTOS/<br>" +
        "Permission status: somehow granted 😭";

    },3900);

    addFakePopup(
      "Virus Detected",
      "9 questionable images found.",
      4500
    );

    addFakePopup(
      "System Alert",
      "Birthday girl embarrassment level rising.",
      5100
    );

    window.setTimeout(function(){

      fill.style.width =
        "63%";

      percent.textContent =
        "63%";

      title.textContent =
        "PHOTO DATABASE COMPROMISED";

      log.innerHTML =
        "Image files duplicating...<br>" +
        "IMG_2914.jpg copied<br>" +
        "IMG_2913.jpg copied<br>" +
        "IMG_2912.jpg copied<br>" +
        "STOPPING PROCESS... FAILED";

    },5400);

    addFakePopup(
      "Fatal Error",
      "Unable to contain embarrassing images.",
      5900
    );

    window.setTimeout(function(){

      fill.style.width =
        "82%";

      percent.textContent =
        "82%";

      title.textContent =
        "SYSTEM FAILURE";

      log.innerHTML =
        "Error: TOO_MANY_MOM_PHOTOS<br>" +
        "Error: STORAGE_OVERFLOW<br>" +
        "Error: MICHAEL_WHY";

    },6500);

    window.setTimeout(function(){

      glitch.classList.remove(
        "active"
      );

      app.classList.remove(
        "virus-shake"
      );

      popupOverlay.classList.remove(
        "active"
      );

      startPhotoInfection();

    },7600);
  }

  /*
  =====================================
  SLOWER PHOTO INFECTION
  =====================================
  */

  function startPhotoInfection(){

    var overlay =
      el("mom-photo-infection");

    var title =
      el("mom-infection-title");

    /*
    Clean out any photos from
    a previous playthrough.
    */

    var oldPhotos =
      overlay.querySelectorAll(
        ".infection-photo"
      );

    oldPhotos.forEach(function(photo){
      photo.remove();
    });

    overlay.classList.add(
      "active"
    );

    title.innerHTML =
      "OH NO.<br>THE PHOTOS ESCAPED. 😭";

    /*
    12 pictures on iPhone.
    18 pictures on MacBook/desktop.

    Since there are 9 unique pictures,
    this guarantees she sees all of them.
    */

    var photoCount =
      window.innerWidth < 700
        ? 12
        : 18;

    /*
    Photos now appear every
    260 milliseconds instead
    of every 95 milliseconds.
    */

    for(
      var i = 0;
      i < photoCount;
      i++
    ){

      (function(i){

        window.setTimeout(function(){

          var pic =
            document.createElement(
              "img"
            );

          pic.className =
            "infection-photo";

          pic.src =
            VIRUS_PHOTOS[
              i %
              VIRUS_PHOTOS.length
            ];

          /*
          Keep them a little farther
          away from the edges so more
          of the picture stays visible.
          */

          pic.style.left =
            Math.floor(
              Math.random()*78
            ) + "%";

          pic.style.top =
            Math.floor(
              Math.random()*72
            ) + "%";

          /*
          Random rotation/size,
          but not so extreme that
          the photo is impossible
          to actually see.
          */

          var rotation =
            Math.random()*36 - 18;

          var scale =
            0.78 +
            Math.random()*0.42;

          pic.style.transform =
            "rotate(" +
            rotation +
            "deg) scale(" +
            scale +
            ")";

          /*
          Later photos appear above
          earlier photos.
          */

          pic.style.zIndex =
            710 + i;

          overlay.appendChild(
            pic
          );

        },i*260);

      })(i);
    }

    /*
    Give her time to actually
    look at the pictures.
    */

    window.setTimeout(function(){

      title.innerHTML =
        "WHY ARE THERE<br>SO MANY OF YOU 😭";

    },4500);

    window.setTimeout(function(){

      title.innerHTML =
        "ATTEMPTING<br>QUARANTINE...";

    },7000);

    window.setTimeout(function(){

      title.innerHTML =
        "THREAT IDENTIFIED:<br>MICHAEL";

    },9000);

    window.setTimeout(function(){

      title.innerHTML =
        "REMOVING VIRUS...<br>99%";

    },11000);

    /*
    Hold everything on-screen
    a little longer before clearing.
    */

    window.setTimeout(function(){

      title.innerHTML =
        "QUARANTINE COMPLETE.<br><br>" +
        "Unfortunately the photos<br>" +
        "have already been seen. 😭";

    },12200);

    /*
    End the prank after 14.5 seconds.
    */

    window.setTimeout(function(){

      var photos =
        overlay.querySelectorAll(
          ".infection-photo"
        );

      photos.forEach(
        function(photo){

          photo.remove();

        }
      );

      overlay.classList.remove(
        "active"
      );

      show(
        "mom-quiz"
      );

      loadQuestion();

    },14500);
  }

  function finishQuiz(){

    el("mom-score-value")
      .textContent =
      score;

    var text;

    if(score === 50){

      text =
        "PERFECT SCORE. You just won a life-changing $50. 😭";

    }else if(score >= 35){

      text =
        "Not bad. That might cover one airport meal and half a Modelo. 😂";

    }else if(score >= 20){

      text =
        "Okay... maybe this covers airport parking.";

    }else{

      text =
        "Mom... this might not even cover parking at the airport. 😭";

    }

    el("mom-score-message")
      .textContent =
      text;

    show(
      "mom-score"
    );
  }

  function confetti(){

    var colors = [
      "#ffffff",
      "#ff385c",
      "#f0d083",
      "#8ecba1",
      "#e59aa9"
    ];

    for(
      var i = 0;
      i < 150;
      i++
    ){

      (function(){

        var piece =
          document.createElement(
            "div"
          );

        piece.className =
          "confetti";

        piece.style.left =
          Math.random()*100 +
          "vw";

        piece.style.background =
          colors[
            Math.floor(
              Math.random() *
              colors.length
            )
          ];

        piece.style.animationDuration =
          (
            2.5 +
            Math.random()*4
          ) +
          "s";

        piece.style.animationDelay =
          (
            Math.random()*.7
          ) +
          "s";

        el("mom-birthday-app")
          .appendChild(
            piece
          );

        window.setTimeout(
          function(){

            if(piece.parentNode){
              piece.remove();
            }

          },
          7500
        );

      })();
    }
  }

  function revealRealGift(){

    show(
      "mom-fakeout"
    );

    var text =
      el("mom-fake-text");

    var money =
      el("mom-real-money");

    var next =
      el("mom-fake-next");

    text.textContent =
      "Wait.";

    money.style.display =
      "none";

    next.style.display =
      "none";

    window.setTimeout(function(){

      text.innerHTML =
        "After all that...<br><br>" +
        "you officially won...<br><br>" +
        "<strong>$" +
        score +
        "</strong>. 😭";

    },1300);

    window.setTimeout(function(){

      text.innerHTML =
        "Huge day financially.<br><br>" +
        "Please don't spend it all in one place.";

    },3800);

    window.setTimeout(function(){

      text.innerHTML =
        "Okay.<br><br>I'm kidding.";

    },6000);

    window.setTimeout(function(){

      text.innerHTML =
        "I wasn't actually going to make<br>" +
        "my mom earn her own<br>" +
        "birthday present. ❤️";

    },7700);

    window.setTimeout(function(){

      text.innerHTML =
        "You were getting it<br>" +
        "no matter what.";

    },9700);

    window.setTimeout(function(){

      text.innerHTML =
        "Your REAL vacation fund is...";

    },11300);

    window.setTimeout(function(){

      money.style.display =
        "block";

      var values = [
        50,
        100,
        150,
        200,
        250,
        300,
        350,
        400,
        450,
        500
      ];

      var valueIndex =
        0;

      function countUp(){

        if(
          valueIndex >=
          values.length
        ){
          return;
        }

        var amount =
          values[valueIndex];

        money.textContent =
          "$" +
          amount;

        el("mom-money")
          .textContent =
          amount;

        valueIndex =
          valueIndex + 1;

        window.setTimeout(
          countUp,
          260
        );
      }

      countUp();
      confetti();

    },12600);

    window.setTimeout(function(){

      text.innerHTML =
        "Yep. $500.<br>" +
        "No quiz required. ❤️";

      next.style.display =
        "inline-block";

    },15500);
  }

  document
    .querySelectorAll(
      "#mom-birthday-app [data-go]"
    )
    .forEach(function(button){

      button.addEventListener(
        "click",
        function(){

          show(
            button.getAttribute(
              "data-go"
            )
          );

        }
      );

    });

  el("mom-start")
    .addEventListener(
      "click",
      function(){

        index = 0;
        score = 0;
        trip = "";
        upgrade = "";
        virusPlayed = false;

        updateMoney();

        show(
          "mom-quiz"
        );

        loadQuestion();

      }
    );

  el("mom-rage-next")
    .addEventListener(
      "click",
      function(){

        el("mom-rage-next")
          .style.display =
          "none";

        advance();

      }
    );

  el("mom-shoutout1-next")
    .addEventListener(
      "click",
      function(){

        show(
          "mom-quiz"
        );

        loadQuestion();

      }
    );

  el("mom-shoutout2-next")
    .addEventListener(
      "click",
      function(){

        show(
          "mom-quiz"
        );

        loadQuestion();

      }
    );

  el("mom-shoutout3-next")
    .addEventListener(
      "click",
      function(){

        show(
          "mom-quiz"
        );

        loadQuestion();

      }
    );

  document
    .querySelectorAll(
      ".mom-trip-choice"
    )
    .forEach(function(card){

      card.addEventListener(
        "click",
        function(){

          document
            .querySelectorAll(
              ".mom-trip-choice"
            )
            .forEach(
              function(other){

                other.classList.remove(
                  "selected"
                );

              }
            );

          card.classList.add(
            "selected"
          );

          trip =
            card.getAttribute(
              "data-choice"
            );

          el("mom-trip-next")
            .classList.add(
              "ready"
            );

        }
      );

    });

  el("mom-trip-next")
    .addEventListener(
      "click",
      function(){

        show(
          "mom-quiz"
        );

        loadQuestion();

      }
    );

  document
    .querySelectorAll(
      ".mom-upgrade-choice"
    )
    .forEach(function(card){

      card.addEventListener(
        "click",
        function(){

          document
            .querySelectorAll(
              ".mom-upgrade-choice"
            )
            .forEach(
              function(other){

                other.classList.remove(
                  "selected"
                );

              }
            );

          card.classList.add(
            "selected"
          );

          upgrade =
            card.getAttribute(
              "data-choice"
            );

          el("mom-upgrade-next")
            .classList.add(
              "ready"
            );

        }
      );

    });

  el("mom-upgrade-next")
    .addEventListener(
      "click",
      function(){

        show(
          "mom-quiz"
        );

        loadQuestion();

      }
    );

  el("mom-rage-finish")
    .addEventListener(
      "click",
      finishQuiz
    );

  el("mom-heartfelt-next")
    .addEventListener(
      "click",
      function(){

        show(
          "mom-heartfelt"
        );

      }
    );

  el("mom-real-reveal")
    .addEventListener(
      "click",
      revealRealGift
    );

  el("mom-fake-next")
    .addEventListener(
      "click",
      function(){

        el("mom-trip-result")
          .textContent =
          trip ||
          "✨ Surprise me";

        el("mom-upgrade-result")
          .textContent =
          upgrade ||
          "❤️ Somewhere nice";

        show(
          "mom-trip"
        );

      }
    );

  el("mom-send-code")
    .addEventListener(
      "click",
      function(){

        var button =
          el("mom-send-code");

        var status =
          el("mom-send-status");

        button.disabled =
          true;

        button.textContent =
          "SENDING REQUEST...";

        /*
        If Formspree hasn't been
        configured yet, still let
        the birthday experience
        finish normally.
        */

        if(
          FORM_ENDPOINT.indexOf(
            "YOUR_FORM_ID"
          ) !== -1
        ){

          window.setTimeout(
            function(){

              confetti();

              show(
                "mom-final"
              );

            },
            650
          );

          return;
        }

        fetch(
          FORM_ENDPOINT,
          {
            method:
              "POST",

            headers:{
              "Content-Type":
                "application/json",

              "Accept":
                "application/json"
            },

            body:
              JSON.stringify({

                subject:
                  "Mom requested her Airbnb birthday code 🎁",

                message:
                  "Mom finished the birthday game and pressed SEND ME MY CODE.",

                quiz_score:
                  "$" +
                  score,

                real_gift:
                  "$500 Airbnb gift card",

                getaway:
                  trip,

                preference:
                  upgrade

              })
          }
        )
        .then(function(response){

          if(!response.ok){

            throw new Error(
              "Request failed"
            );

          }

          confetti();

          show(
            "mom-final"
          );

        })
        .catch(function(){

          status.textContent =
            "Couldn't send automatically. Tell Michael you're ready for your code ❤️";

          button.disabled =
            false;

          button.textContent =
            "TRY AGAIN 🎁";

        });

      }
    );

})();